<template>
  <div class="account_content">
    <div class="account_content_header">
      <div class="account_content_header_title">
        <span>Data Analysis</span>
        <el-button type="text">Re select data</el-button>
      </div>
      <div class="account_content_header_tab">
        <div class="account_content_header_tab_item active">
          Industry Analysis
        </div>
        <div class="account_content_header_tab_item" @click="linkToAnalysis">
          Enterprise Analysis
        </div>
      </div>
      <div class="account_content_header_box">
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            Number of selected enterprises
          </span>
          <span class="account_content_header_box_item_value">100</span>
        </div>
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            Number of selected enterprise industries
          </span>
          <span class="account_content_header_box_item_value">10</span>
        </div>
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            The country where the selected enterprise
          </span>
          <span class="account_content_header_box_item_value">4</span>
        </div>
        <div class="account_content_header_box_item">
          <span class="account_content_header_box_item_title">
            Industry Prospects
          </span>
          <span class="account_content_header_box_item_value">
            <div>Good 4</div>
            <div>Average 2</div>
            <div>Poor 2</div>
            <div>Unknown 2</div>
          </span>
        </div>
      </div>
    </div>
    <div class="account_content_wrapper">
      <div class="account_content_wrapper_list">
        <div
          class="account_content_wrapper_list_item"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div class="account_item_title">
            <span class="item_no">{{ index + 1 }}</span>
            <span class="item_title">
              {{ item.name }}
            </span>
            <i
              class="iconfont icon-lujing"
              :class="item.isShowDetail ? 'active' : ''"
              @click="showDetail(item)"
            />
          </div>
          <div class="account_item_content">
            <div class="account_item_content_item">
              <span class="content_item_title">ISIC:</span>
              <span class="content_item_value">{{ item.isic }}</span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title">
                Total number of industry enterprises:
              </span>
              <span class="content_item_value">{{
                item.totalEnterprises
              }}</span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title">
                Average Revenue Range by Country and Industry for
                Enterprise-Owned Businesses:
              </span>
              <span class="content_item_value">{{ item.revenueRange }}</span>
            </div>
          </div>
          <div class="account_item_content">
            <div class="account_item_content_item">
              <span class="content_item_title">Country:</span>
              <span class="content_item_value">
                <img
                  v-for="list in item.country"
                  :src="require('../../../../static' + getCountryImgUrl(list))"
                />
              </span>
            </div>
            <div class="account_item_content_item">
              <span class="content_item_title"> Outlook: </span>
              <span class="content_item_value">{{ item.outlook }}</span>
            </div>
          </div>
          <div class="account_item_content" v-show="item.isShowDetail">
            <div class="account_item_content_detail">
              <div class="industry_ranking">
                <div class="detail_item_title">
                  Industry Ranking of Selected Enterprises
                  <el-button
                    type="text"
                    :disabled="selectList.length > 1 || selectList.length == 0"
                    >Search Leads</el-button
                  >
                </div>
                <div class="detail_item_search">
                  <el-input
                    class="search-select-con"
                    popper-class="new-search-select"
                    placeholder="Enter Company Name"
                    v-model="searchParams.name"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                  <el-select
                    clearable
                    v-model="searchParams.date"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select Update Date"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in selectOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    clearable
                    v-model="searchParams.country"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select Country"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in selectOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    clearable
                    v-model="searchParams.credit"
                    filterable
                    popper-class="new-search-select"
                    placeholder="Select credit Assessment"
                    :popper-append-to-body="true"
                  >
                    <el-option
                      v-for="(item, index) in selectOptions"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-button class="reset_btn">Reset</el-button>
                  <el-button class="search_btn">Search</el-button>
                </div>
                <el-table
                  class="risk_table"
                  :data="industryRankingData"
                  height="100%"
                  ref="tableRef"
                  :row-key="(row) => row.aaaId"
                  @selection-change="onSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    reserve-selection
                    align="center"
                    class-name="table_check_row"
                    width="40"
                  />
                  <el-table-column
                    prop="ranking"
                    align="left"
                    label="Ranking"
                    min-width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="companyName"
                    label="Company Name"
                    min-width="200"
                  >
                    <template slot-scope="scope">
                      <div class="flex_center_start_box">
                        <span
                          class="link_hover_text"
                          @click="goDetail(scope.row)"
                        >
                          {{ scope.row.companyName }}</span
                        >
                      </div>
                    </template>
                  </el-table-column>

                  <!-- 其他table -->
                  <el-table-column
                    :resizable="false"
                    :prop="col.prop"
                    :column-key="col.prop"
                    :label="col.label"
                    :min-width="col.width"
                    :align="col.align"
                    show-overflow-tooltip
                    v-for="col in showRowList"
                    :key="col.prop"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="" width="40">
                    <template slot="header" slot-scope="scope">
                      <i
                        class="iconfont icon-tianjia1"
                        @click="isShowRowList = !isShowRowList"
                      />
                    </template>
                  </el-table-column>
                </el-table>
                <div class="row_check_box" v-show="isShowRowList">
                  <el-checkbox-group v-model="selectRowListValue">
                    <el-checkbox
                      :label="ops.prop"
                      v-for="(ops, index) in allRowList"
                      :key="index"
                    >
                      {{ ops.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-button class="reset_btn" @click="isShowRowList = false"
                    >Cancel</el-button
                  >
                  <el-button class="search_btn" @click="confirmRowSelection"
                    >Confirm</el-button
                  >
                </div>
              </div>
              <div class="industry_description">
                <div class="detail_item_title">Industry Description</div>
                <div class="industry_description_content">
                  <div class="industry_description_content_left">
                    <div class="industry_description_content_list">
                      <div class="industry_description_content_list_label">
                        Industry Title
                      </div>
                      <div class="industry_description_content_list_value">
                        Specialized design activities
                      </div>
                    </div>
                    <div class="industry_description_content_list">
                      <div class="industry_description_content_list_label">
                        Industry Description
                      </div>
                      <div class="industry_description_content_list_value">
                        This class includes:- fashion design related to
                        textiles, wearing apparel, shoes, jewelry, furniture and
                        other interior decoration and other fashion goods as
                        well as other personal or household goods- industrial
                        design, i.e. creating and developing designs and
                        specifications that optimize the use, value and
                        appearance of products, including the determination of
                        the materials, construction, mechanism, shape, colour
                        and surface finishes of the product, taking into
                        consideration human characteristics and needs, safety,
                        market appeal and efficiency in production,
                        distribution, use and maintenance- activities of graphic
                        designers- activities of interior decorators
                      </div>
                    </div>
                  </div>
                  <div class="industry_description_content_right">
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          ISIC
                        </div>
                        <div class="industry_description_content_list_value">
                          3290
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          ISIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Manufacture of computers and peripheral equipment
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NACE
                        </div>
                        <div class="industry_description_content_list_value">
                          26.20
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NACE Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Manufacture of computers and peripheral equipment
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NAICS
                        </div>
                        <div class="industry_description_content_list_value">
                          334111
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          NAICS Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Electronic Computer Manufacturing
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          CSIC
                        </div>
                        <div class="industry_description_content_list_value">
                          C3911
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          CSIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Complete set of computer manufacturing
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          AAAIC
                        </div>
                        <div class="industry_description_content_list_value">
                          2601
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          AAAIC Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Manufacture of computer, electronic and optical
                          products
                        </div>
                      </div>
                    </div>
                    <div class="industry_description_content_item">
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          GICS
                        </div>
                        <div class="industry_description_content_list_value">
                          45202030
                        </div>
                      </div>
                      <div class="industry_description_content_list">
                        <div class="industry_description_content_list_label">
                          GICS Description
                        </div>
                        <div class="industry_description_content_list_value">
                          Technology Hardware, Storage & Peripherals
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="industry_observation">
                <div class="detail_item_title">Industry Observations</div>
                <el-table
                  class="risk_table merge_table"
                  :data="industryObservationData"
                  height="100%"
                  ref="tableRef"
                >
                  <el-table-column
                    prop="comparison"
                    align="left"
                    label="Comparison"
                  >
                  </el-table-column>

                  <el-table-column
                    prop="average"
                    align="center"
                    label="Average"
                  >
                  </el-table-column>
                  <el-table-column prop="mean" align="center" label="Mean">
                  </el-table-column>
                  <el-table-column prop="max" label="Max(10%)" align="center">
                  </el-table-column>
                  <el-table-column prop="min" align="center" label="Min(10%)">
                  </el-table-column>
                </el-table>
              </div>
              <div class="industry_stats">
                <div class="detail_item_title">Industry Stats</div>
                <el-table
                  class="risk_table merge_table"
                  :data="industryStatsData"
                  height="100%"
                  ref="tableRef"
                >
                  <el-table-column
                    prop="industryStats"
                    align="left"
                    label="Industry Stats"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="industryStats1"
                    align="center"
                    label="2023"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="industryStats2"
                    align="center"
                    label="2022"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="industryStats3"
                    label="2021"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="industryStats4"
                    align="center"
                    label="2020"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="industryStats5"
                    align="center"
                    label="2019"
                  >
                  </el-table-column>
                </el-table>
              </div>
              <div class="industry_performance">
                <div class="detail_item_title">Industry Performance</div>
                <el-table
                  class="risk_table merge_table"
                  :data="industryPerformance"
                  height="100%"
                  ref="tableRef"
                  :row-class-name="
                    (obj) => rowClassName(obj, industryPerformance)
                  "
                  :span-method="
                    (obj) => arraySpanMethod(obj, industryPerformance)
                  "
                >
                  <el-table-column
                    prop="performance"
                    align="left"
                    label="Performance"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performanceType"
                    align="left"
                    min-width="130"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performance1"
                    align="center"
                    label="2023"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performance2"
                    align="center"
                    label="2022"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performance3"
                    label="2021"
                    align="center"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performance4"
                    align="center"
                    label="2020"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="performance5"
                    align="center"
                    label="2019"
                  >
                  </el-table-column>
                </el-table>
              </div>
              <div class="industry_overview">
                <div class="detail_item_title">Industry Overview</div>
                <div class="industry_overview_text">
                  Basic software development (industry code: I6511) refers to
                  software that can schedule and manage hardware resources and
                  provide operating support for application software, including
                  operating systems, databases, middleware, and various types of
                  firmware. It belongs to "information transmission, software
                  and Information technology service industry category-software
                  and information technology service industry category".
                  Statistics from the Bureau of Statistics show that my
                  country’s information transmission, software and information
                  technology service industries:
                  <div>
                    As of 2019, the number of urban non-private enterprises
                    employed was 4.5526 million, a year-on-year increase of
                    7.31%;
                  </div>
                  <div>
                    In 2019, the actual amount of foreign direct investment used
                    was 146.82 Billion US dollars, an increase of 25.91%
                    year-on-year;
                  </div>
                  <div>
                    In 2020, the added value of the industry will be 379.507
                    billion yuan, accounting for 3.74% of GDP. According to
                    Shanganxin's big data research, the basic software
                    development industry;
                  </div>
                  <div>
                    There are 23 Shanghai and Shenzhen listed companies with a
                    total market value of 49,705,805,500 yuan;
                  </div>
                  <div>
                    Medium-sized industry: The number of surviving companies in
                    the industry in 2019 totals 110,510, and the total revenue
                    is in all industries Ranked in the top 16.65% and net profit
                    ranked in the top 94.1%;
                  </div>
                  <div>
                    Industry competition is fierce: In 2019, the industry CR10
                    is >80%, and the average life span of the company is 5.00
                    years, which is a high-flow industry;
                  </div>
                  <div>
                    The industry prospects are better: as of 2019, the industry
                    average Each company has obtained 5.81 patents, and about
                    11.88% of companies have obtained financing, and the CAGR of
                    the industry's net profit in the past three years is
                    373.23%.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination_box">
        <Page
          keyword="Industry Analysis"
          :fontColor="'#1290C9'"
          :total="total"
          :pageSize="pageSize"
          :currentPage="currentPage"
          @onPageChange="onChangePage"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
import Page from "@/views/newLayout/page.vue";
import { mixins1 } from "@/mixins/index";
export default {
  components: {
    Page,
  },
  mixins: [mixins1],
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 1000,
      searchParams: {
        name: "",
        date: "",
        country: "",
        credit: "",
      },
      selectList: [],
      isShowRowList: false,
      selectRowListValue: ["updateDate", "country", "revenue", "credit"],
      showRowList: [
        {
          label: "Update Date",
          prop: "updateDate",
          align: "center",
          width: 120,
        },
        {
          label: "Country",
          prop: "country",
          align: "center",
          width: 120,
        },
        {
          label: "Revenue",
          prop: "revenue",
          align: "center",
          width: 120,
        },
        {
          label: "credit Assessment",
          prop: "credit",
          align: "center",
          width: 120,
        },
      ],
      allRowList: [
        {
          label: "Update Date",
          prop: "updateDate",
          align: "center",
          width: 120,
        },
        {
          label: "Country",
          prop: "country",
          align: "center",
          width: 120,
        },
        {
          label: "Revenue",
          prop: "revenue",
          align: "center",
          width: 120,
        },
        {
          label: "credit Assessment",
          prop: "credit",
          align: "center",
          width: 120,
        },
        {
          label: "Gross margin (%)",
          prop: "grossMargin",
          align: "center",
          width: 120,
        },
        {
          label: "Return on equity (%)",
          prop: "returnOnEquity",
          align: "center",
          width: 120,
        },
        {
          label: "Current ratio (x)",
          prop: "currentRatio",
          align: "center",
          width: 120,
        },
        {
          label: "Quick ratio (x)",
          prop: "quickRatio",
          align: "center",
          width: 120,
        },
        {
          label: "Debt ratio (%)",
          prop: "debtRatio",
          align: "center",
          width: 120,
        },
      ],
      selectOptions: [
        { value: "option1", label: "Option 1" },
        { value: "option2", label: "Option 2" },
        { value: "option3", label: "Option 3" },
      ],
      tableData: [
        {
          id: 1,
          name: "Complete set of computer manufacturing",
          isic: "2620",
          totalEnterprises: 1000,
          revenueRange: "USD 153,000 ~ USD500,000",
          country: ["CN", "AR", "AE", "JP"],
          outlook: "Good",
          isShowDetail: true,
        },
        {
          id: 2,
          name: "Complete set of computer manufacturing",
          isic: "2620",
          totalEnterprises: 1000,
          revenueRange: "USD 153,000 ~ USD500,000",
          country: ["CN", "AR", "AW"],
          outlook: "Good",
          isShowDetail: false,
        },
      ],

      industryRankingData: [
        {
          aaaId: 1,
          ranking: 10,
          companyName: "Company A",
          updateDate: "2024-01-01",
          country: "CN",
          revenue: "USD 101,026 K",
          credit: "AA+",
        },
        {
          aaaId: 2,
          ranking: 20,
          companyName: "Company B",
          updateDate: "2024-01-01",
          country: "US",
          revenue: "USD 101,026 K",
          credit: "A",
        },
        {
          aaaId: 3,
          ranking: 2023,
          companyName: "Company C",
          country: "JP",
          revenue: "USD 101,026 K",
          credit: "A+",
        },
      ],
      industryObservationData: [
        {
          aaaId: 1,
          comparison: "Years in Business",
          average: "3",
          mean: "3",
          max: "3",
          min: "3",
        },
        {
          aaaId: 2,
          comparison: "Revenue",
          average: "2,308",
          mean: "2,308",
          max: "2,308",
          min: "2,308",
        },
        {
          aaaId: 3,
          comparison: "Net Earning",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 4,
          comparison: "Total Assets",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 5,
          comparison: "Total Liability",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 6,
          comparison: "Total Net Earning",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 7,
          comparison: "Total Operating Cost",
          average: "78,837",
          mean: "78,837",
          max: "78,837",
          min: "78,837",
        },
        {
          aaaId: 8,
          comparison: "Return on equity (%)",
          average: "53.28%",
          mean: "53.28%",
          max: "53.28%",
          min: "53.28%",
        },
        {
          aaaId: 9,
          comparison: "Return on Assets (ROA)",
          average: "104.31%",
          mean: "104.31%",
          max: "104.31%",
          min: "104.31%",
        },
        {
          aaaId: 10,
          comparison: "Profit margin (%)",
          average: "89.78%",
          mean: "89.78%",
          max: "89.78%",
          min: "89.78%",
        },
        {
          aaaId: 11,
          comparison: "Gross margin (%)",
          average: "48.91%",
          mean: "48.91%",
          max: "48.91%",
          min: "48.91%",
        },
        {
          aaaId: 12,
          comparison: "Asset turnover (x)",
          average: "225.76%",
          mean: "225.76%",
          max: "225.76%",
          min: "225.76%",
        },
      ],
      industryStatsData: [
        {
          aaaId: 1,
          industryStats: "Number of companies in this industry",
          industryStats1: "314,977",
          industryStats2: "314,977",
          industryStats3: "314,977",
          industryStats4: "314,977",
          industryStats5: "314,977",
        },
        {
          aaaId: 2,
          industryStats: "Number of large companies",
          industryStats1: "303",
          industryStats2: "303",
          industryStats3: "303",
          industryStats4: "303",
          industryStats5: "303",
        },
        {
          aaaId: 3,
          industryStats: "Number of SMEs",
          industryStats1: "303",
          industryStats2: "303",
          industryStats3: "303",
          industryStats4: "303",
          industryStats5: "303",
        },
        {
          aaaId: 4,
          industryStats: "Number of companies in samples",
          industryStats1: "79,140",
          industryStats2: "79,140",
          industryStats3: "79,140",
          industryStats4: "79,140",
          industryStats5: "79,140",
        },
        {
          aaaId: 5,
          industryStats: "Companies in Loss",
          industryStats1: "42,568",
          industryStats2: "42,568",
          industryStats3: "42,568",
          industryStats4: "42,568",
          industryStats5: "42,568",
        },
        {
          aaaId: 6,
          industryStats: "Geographic Distribution",
          industryStats1: "Upper and Middle Rea...",
          industryStats2: "Upper and Middle Rea...",
          industryStats3: "Upper and Middle Rea...",
          industryStats4: "Upper and Middle Rea...",
          industryStats5: "Upper and Middle Rea...",
        },
      ],
      industryPerformance: [
        {
          performance: "Profitability Ratios",
          performanceType: "Return on equity (%)",
          performance1: "42.81%",
          performance2: "42.81%",
          performance3: "42.81%",
          performance4: "42.81%",
          performance5: "42.81%",
        },
        {
          performance: "Profitability Ratios",
          performanceType: "Return on assets (%)",
          performance1: "-4.59%",
          performance2: "-4.59%",
          performance3: "-4.59%",
          performance4: "-4.59%",
          performance5: "-4.59%",
        },
        {
          performance: "Profitability Ratios",
          performanceType: "Profit margin (%)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Profitability Ratios",
          performanceType: "Gross margin (%)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Operating Ratios",
          performanceType: "Asset turnover (x)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Operating Ratios",
          performanceType: "Stock turnover (x)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Operating Ratios",
          performanceType: "Sales period (days)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Operating Ratios",
          performanceType: "Collection period (days)",
          performance1: "-5.73%",
          performance2: "-5.73%",
          performance3: "-5.73%",
          performance4: "-5.73%",
          performance5: "-5.73%",
        },
        {
          performance: "Operating Ratios",
          performanceType: "Credit period (days)",
          performance1: "1.54",
          performance2: "1.54",
          performance3: "1.54",
          performance4: "1.54",
          performance5: "1.54",
        },
        {
          performance: "Structure Ratios",
          performanceType: "Current ratio (x)",
          performance1: "27.65",
          performance2: "27.65",
          performance3: "27.65",
          performance4: "27.65",
          performance5: "27.65",
        },
        {
          performance: "Structure Ratios",
          performanceType: "Quick ratio (x)",
          performance1: "-",
          performance2: "-",
          performance3: "-",
          performance4: "-",
          performance5: "-",
        },
        {
          performance: "Structure Ratios",
          performanceType: "Shareholder liquidity ratio (x)",
          performance1: "144.26",
          performance2: "144.26",
          performance3: "144.26",
          performance4: "144.26",
          performance5: "144.26",
        },
        {
          performance: "Structure Ratios",
          performanceType: "Debt ratio (%)",
          performance1: "-",
          performance2: "-",
          performance3: "-",
          performance4: "-",
          performance5: "-",
        },
        {
          performance: "Productivity Ratios",
          performanceType: "Profit per employee (th)",
          performance1: "28",
          performance2: "28",
          performance3: "28",
          performance4: "28",
          performance5: "28",
        },
        {
          performance: "Productivity Ratios",
          performanceType: "Operating revenue per employee (th)",
          performance1: "28",
          performance2: "28",
          performance3: "28",
          performance4: "28",
          performance5: "28",
        },
        {
          performance: "Productivity Ratios",
          performanceType: "Shareholder funds per employee (th)",
          performance1: "28",
          performance2: "28",
          performance3: "28",
          performance4: "28",
          performance5: "28",
        },
        {
          performance: "Productivity Ratios",
          performanceType: "Total assets per employee (th)",
          performance1: "499",
          performance2: "499",
          performance3: "499",
          performance4: "499",
          performance5: "499",
        },
        {
          performance: "Growth Ratios",
          performanceType: "Sales Growth Rate (%)",
          performance1: "-",
          performance2: "-",
          performance3: "-",
          performance4: "-",
          performance5: "-",
        },
        {
          performance: "Growth Ratios",
          performanceType: "Net Profit Growth Rate (%)",
          performance1: "-",
          performance2: "-",
          performance3: "-",
          performance4: "-",
          performance5: "-",
        },
        {
          performance: "Growth Ratios",
          performanceType: "Total Assets Growth Rate (%)",
          performance1: "-",
          performance2: "-",
          performance3: "-",
          performance4: "-",
          performance5: "-",
        },
      ],
    };
  },

  beforeDestroy() {},

  methods: {
    // 能力表现单元格合并
    arraySpanMethod({ row, column, rowIndex, columnIndex }, list) {
      if (columnIndex === 0) {
        let prevRow = list[rowIndex - 1];
        let nextRow = list[rowIndex + 1];

        if (prevRow && row.performance == prevRow.performance) {
          //当有上一条数据，并且和当前类型相同

          return {
            rowspan: 0,
          };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow.performance == row.performance) {
            //当有下一条数据并且和当前类型相同时,获取新的下一条
            countRowspan++;
            nextRow = list[rowIndex + countRowspan];
            console.log(row, prevRow, nextRow);
          }
          return {
            rowspan: countRowspan,
            colspan: 1,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }; // 默认不合并其他列
    },
    rowClassName({ row, rowIndex }, list) {
      // 获取能力表现合并行每一组对应的行号
      const data = list || [];
      // 第一行一定是新组
      if (rowIndex === 0) {
        return "line_cell_item";
      }
      const current = data[rowIndex];
      const prev = data[rowIndex - 1];
      // 和上一行不同，说明是新组第一行
      if (prev && current.performance !== prev.performance) {
        return "line_cell_item";
      }

      return "";
    },

    onChangePage(pagParm) {
      this.currentPage = pagParm.page;
      this.pageSize = pagParm.pageSize;
      // this.getPageList();
    },
    showDetail(item) {
      item.isShowDetail = !item.isShowDetail;
      this.tableData.forEach((i) => {
        if (i.id !== item.id) {
          i.isShowDetail = false;
        }
      });
    },
    resetDetailTable() {
      this.searchParams = {
        name: "",
        date: "",
        country: "",
        credit: "",
      };
      this.selectList = [];
    },
    // 选择展示的列
    confirmRowSelection() {
      this.showRowList = this.allRowList.filter((item) =>
        this.selectRowListValue.includes(item.prop),
      );
      this.isShowRowList = false;
    },
    // 表格选择改变时
    onSelectionChange(val) {
      this.selectList = val;
    },
    linkToAnalysis() {
      this.$router.push({
        path: "/account/enterpriseAnalysis",
        // query: {
        //   id3a: this.$route.query.id3a,
        //   keyword: this.$route.query.keyword,
        //   selectKey: this.$route.query.selectKey,
        //   type: String(index),
        // },
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.account_content {
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.account_content_header {
  height: 220px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px;
}
.account_content_wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.account_content_header_title {
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.account_content_header_title span {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 34px;
  text-align: left;
}
.account_content_header_title .el-button {
  color: #1290c9;
}
.account_content_header_tab {
  width: fit-content;
  margin: 10px auto 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  background: #f5f5f5;
  border-radius: 4px;
}
.account_content_header_tab_item {
  padding: 9px 20px;
  height: 40px;
  font-size: 18px;
  color: #1a2332;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}
.account_content_header_tab_item.active {
  font-family: Arial Bold;
  background: #ffffff;
  border-radius: 4px;
}
.account_content_header_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.account_content_header_box_item {
  flex: 1;
  padding: 10px 20px;
  height: 70px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #a2a9b0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
}
.account_content_header_box_item_title {
  font-size: 18px;
  color: #1a2332;
  line-height: 18px;
  text-align: center;
  font-style: normal;
}
.account_content_header_box_item_value {
  width: 100%;
  font-size: 18px;
  color: #1290c9;
  line-height: 18px;
  text-align: center;
  font-style: normal;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.account_content_wrapper_list {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.account_content_wrapper_list_item {
  width: 100%;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 20px 30px 30px 60px;
}
.account_item_title {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}
.item_no {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1290c9;
  text-align: center;
  font-style: normal;
  position: absolute;
  left: -40px;
}
.item_title {
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  text-align: left;
  font-style: normal;
}
.account_item_title .icon-lujing {
  font-size: 18px;
  color: #1290c9;
  cursor: pointer;
  transform: rotate(90deg);
  transition: all ease-in-out 0.2s;
}
.account_item_title .icon-lujing.active {
  transform: rotate(270deg);
}
.account_item_content {
  margin-top: 20px;
  display: flex;
  gap: 41px;
}
.account_item_content_item {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}
.account_item_content_item + .account_item_content_item::before {
  content: "";
  width: 1px;
  height: 14px;
  background: #dddddd;
  position: absolute;
  left: -20px;
  /* top: 50%;
  transform: translateY(-50%); */
}
.content_item_title {
  font-size: 18px;
  color: #666666;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.content_item_value {
  font-size: 18px;
  color: #1a2332;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}
.content_item_value img {
  width: 40px;
  height: 24px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
  margin-right: 10px;
}
.account_item_content_detail {
  width: 100%;
  height: auto;
}
.account_item_content_detail > div {
  border-top: 1px solid #a2a9b0;
  padding-top: 30px;
  padding-bottom: 30px;
}
.account_item_content_detail .industry_overview {
  padding-bottom: 0px;
}
.detail_item_title {
  height: 30px;
  font-family: Arial Bold;
  font-size: 24px;
  color: #1a2332;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}
.detail_item_title .el-button {
  float: right;
  font-size: 20px;
  color: #999999;
  text-align: right;
  font-style: normal;
  text-decoration-line: underline;
}
.detail_item_search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  margin-bottom: 20px;
}
.detail_item_search > div {
  flex: 1;
  min-width: 0;
}
.detail_item_search >>> .el-input__inner {
  height: 40px;
  box-sizing: border-box;
}
.reset_btn {
  width: 100px;
  height: 40px;
  background: #eeeeee;
  border-radius: 10px;
  font-size: 18px;
  line-height: 40px;
  color: #1a2332;
  text-align: center;
  font-style: normal;
  margin-left: 10px;
  padding: 0;
}
.search_btn {
  width: 100px;
  height: 40px;
  background: #1290c9;
  border-radius: 10px;
  font-size: 18px;
  line-height: 40px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  margin-left: 0px;
  padding: 0;
}
.icon-tianjia1 {
  cursor: pointer;
  font-size: 20px;
  color: #1290c9;
}
.industry_ranking {
  position: relative;
}
.row_check_box {
  position: absolute;
  top: 170px;
  right: 0;
  padding: 20px;
  width: auto;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
}
.row_check_box .el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}
.row_check_box .reset_btn {
  margin-right: 10px;
}
.industry_description_content {
  display: flex;
  gap: 60px;
}
.industry_description_content_left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.industry_description_content_right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.industry_description_content_item {
  width: 100%;
  height: 108px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 20px;
}
.industry_description_content_list {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.industry_description_content_list_label {
  width: 162px;
  font-family: Arial Bold;
  font-size: 18px;
  color: #1a2332;
  line-height: 26px;
}
.industry_description_content_list_value {
  flex: 1;
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
}
.industry_description_content_left .industry_description_content_list_label {
  width: 118px;
}
.industry_description_content_right .industry_description_content_list_value {
  color: #29445d;
}
.merge_table >>> .el-table__body tr td:first-child {
  background: #f2f5f9;
}
.merge_table >>> .el-table__body .line_cell_item td:nth-child(2) {
  background: #f2f5f9;
}
.merge_table >>> .el-table__body .line_cell_item td:nth-child(1) {
  border-right: 1px solid #cccccc;
}
.industry_overview_text {
  font-size: 18px;
  color: #1a2332;
  line-height: 30px;
  text-align: justify;
  font-style: normal;
}
.industry_overview_text div {
  margin-top: 10px;
  padding-left: 16px;
  position: relative;
}
.industry_overview_text div:first-child {
  margin-top: 20px;
}
.industry_overview_text div::before {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  background: #1a2332;
  border-radius: 50%;
  position: absolute;
  left: 2px;
  top: 12px;
}
.link_hover_text {
  color: #1290c9;
}
.risk_table
  .el-table__body
  tr:hover
  > td.el-table__cell:not(.el-table__expanded-cell)
  .link_hover_text {
  color: #1290c9;
  text-decoration: underline;
}

@media (max-width: 1920px) {
  .account_content {
    gap: 8px;
  }
  .account_content_header {
    height: 170px;
    padding: 14px;
  }
  .account_content_header_title {
    padding-left: 8px;
  }
  .account_content_header_title span {
    font-size: 18px;
    line-height: 26px;
  }
  .account_content_header_tab {
    margin: 8px auto 14px;
    height: 36px;
    padding: 5px 14px;
  }
  .account_content_header_tab_item {
    padding: 7px 14px;
    height: 30px;
    font-size: 14px;
  }

  .account_content_header_box {
    gap: 12px;
  }
  .account_content_header_box_item {
    padding: 8px 14px;
    height: 55px;
  }
  .account_content_header_box_item_title {
    font-size: 14px;
    line-height: 14px;
  }
  .account_content_header_box_item_value {
    font-size: 14px;
    line-height: 14px;
  }
  .account_content_wrapper_list {
    gap: 8px;
  }
  .account_content_wrapper_list_item {
    padding: 14px 22px 22px 44px;
  }
  .account_item_title {
    gap: 8px;
  }
  .item_no {
    font-size: 18px;
    left: -30px;
  }
  .item_title {
    font-size: 18px;
  }
  .account_item_title .icon-lujing {
    font-size: 14px;
  }
  .account_item_content {
    margin-top: 14px;
    gap: 30px;
  }
  .account_item_content_item {
    gap: 8px;
  }
  .account_item_content_item + .account_item_content_item::before {
    height: 12px;
    left: -15px;
  }
  .content_item_title {
    font-size: 14px;
    line-height: 18px;
  }
  .content_item_value {
    font-size: 14px;
    line-height: 18px;
  }
  .content_item_value img {
    width: 30px;
    height: 20px;
    margin-right: 8px;
  }
  .account_item_content_detail > div {
    padding-top: 22px;
    padding-bottom: 22px;
  }
  .detail_item_title {
    height: 22px;
    font-size: 18px;
    line-height: 22px;
    margin-bottom: 14px;
  }
  .detail_item_title .el-button {
    font-size: 16px;
  }
  .detail_item_search {
    gap: 8px;
    height: 30px;
    margin-bottom: 14px;
  }
  .detail_item_search >>> .el-input__inner {
    height: 30px;
    font-size: 14px;
  }
  .reset_btn {
    width: 80px;
    height: 30px;
    border-radius: 8px;
    font-size: 14px;
    margin-left: 8px;
    line-height: 30px;
  }
  .search_btn {
    width: 80px;
    height: 30px;
    border-radius: 8px;
    font-size: 14px;
    margin-left: 8px;
    line-height: 30px;
  }
  .icon-tianjia1 {
    font-size: 16px;
  }

  .row_check_box {
    top: 130px;
    padding: 14px;
  }
  .row_check_box .el-checkbox-group {
    gap: 14px;
    margin-bottom: 14px;
  }
  .row_check_box .reset_btn {
    margin-right: 8px;
  }
  .industry_description_content {
    gap: 45px;
  }
  .industry_description_content_left {
    gap: 12px;
  }
  .industry_description_content_right {
    gap: 14px;
  }
  .industry_description_content_item {
    height: 80px;
    padding: 14px;
  }
  .industry_description_content_list {
    gap: 14px;
    margin-bottom: 12px;
  }

  .industry_description_content_list_label {
    width: 125px;
    font-size: 14px;
    line-height: 20px;
  }
  .industry_description_content_list_value {
    flex: 1;
    font-size: 14px;
    line-height: 22px;
  }
  .industry_description_content_left .industry_description_content_list_label {
    width: 85px;
  }

  .industry_overview_text {
    font-size: 14px;
    line-height: 22px;
  }
  .industry_overview_text div {
    margin-top: 8px;
    padding-left: 14px;
  }
  .industry_overview_text div:first-child {
    margin-top: 14px;
  }
  .industry_overview_text div::before {
    width: 5px;
    height: 5px;
    left: 2px;
    top: 9px;
  }
}
</style>
